import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TelegramIcon(props: IconProps) {
    return <Icon {...props} iconKey={"telegram"}/>
}
